import React from 'react';

const AdminNavbar = ({ activeTabHandler, activeTab }) => {
  return (
    <div className='admin-section-tabs'>
      <ul>
        <li
          className={activeTab === 'user' ? 'selected-admin-nav' : ''}
          onClick={() => activeTabHandler('user')}
        >
          <p>User</p>
        </li>
        <li
          className={activeTab === 'projects' ? 'selected-admin-nav' : ''}
          onClick={() => activeTabHandler('projects')}
        >
          <p>Projects</p>
        </li>
        <li
          className={activeTab === 'experience' ? 'selected-admin-nav' : ''}
          onClick={() => activeTabHandler('experience')}
        >
          <p>Experience</p>
        </li>
      </ul>
    </div>
  );
};

export default AdminNavbar;
